import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiOutlineTrophy } from "react-icons/ai";
import fbImg from "../../assets/FB2023.jpeg";
import rcImg from "../../assets/RC25.jpeg";

function Experience() {
  const workExperience = [
    {
      role: "Founding Mechanical Engineer",
      company: "Armatrix Automations Pvt. Ltd.",
      date: "March 2026 - Present",
      points: [
        "Developing intelligent hyper redundant robotic arms with fine position and orientation control which can access confined and hazardous spaces beyond human reach for welding, painting, visual inspection and other MRO related tasks",
      ],
    },
    {
      role: "Mechanical Engineer",
      company: "Rekise Marine Pvt. Ltd.",
      date: "May 2025 - March 2026",
      points: [
        "Executed complete development of fin and propeller enclosure, from CAD and manufacturing to assembly, integration, and sealing",
        "Developed a thermal testing rig to characterize heat-pipe performance, thermal resistances, and efficiency under controlled conditions",
        "Executed mast system load analysis with sea-wash forces and engineered a rotary actuation system with spring-assisted deployment",
        "Designed a ballast system replacing large tanks with multiple smaller units, improving safety, trim control, and reducing system weight",
        "Designed free-flooded structural frames for a new vessel prototype and performed load analysis FEA for a high capacity vessel",
      ],
    },
  ];

  const internships = [
    {
      role: "Prototype Design of a Low-Cost EVAP System for Two Wheelers",
      company: "Bajaj Auto Ltd.",
      date: "May 2024 - July 2024",
      location: "Pune, India",
      points: [
        "Formulated the design checklist to meet BS-VI SHED and Indian BIS emission testing standards by analysing two wheeler fuel tank EVAP",
        "Achieved a significant cost reduction by conducting competitive benchmarking of existing EVAP systems and developing an alternative design",
        "Engineered a compact rollover valve assembly using leakage-proof projection welding and optimised through substantial part count reduction",
        "Leveraged Ansys CAE pressure analysis on O-Ring, ensuring hermetic sealing under compression to withstand excess pressure",
      ],
    },
  ];

  const competitions = [
    {
      title: "Formula Bharat 2023",
      org: "TeamKART Formula SAE",
      location: "Coimbatore, India | Jan 2023",
      image: fbImg,
      points: [
        "Secured 8th overall among 70+ university teams across India in the on-site Combustion Vehicles category",
        "Bagged 3rd position in the Cost and Manufacturing Event, one of only 4 CV teams to clear all technical inspections",
        "Analysed 40+ failure modes constituting the FMEA and prepared comprehensive vehicle design documentation",
      ],
    },
    {
      title: "IMechE Railway Challenge 2024",
      org: "TeamTRAK Railway Research Group",
      location: "Stapleford, United Kingdom | Jun 2024",
      image: rcImg,
      points: [
        "Co-founded India's first student railway research group with a vision to bring about a technological revolution in the Indian Railways",
        "Secured runners-up in the on-site entry-level competition, being the only non-European team and the first to represent India",
        "Presented a miniature locomotive design with efficient regenerative braking, autonomous operation and safety features",
      ],
    },
  ];

  return (
    <section className="section">
      <Container>
        <h2 className="section-title fade-in">
          Work <span className="purple">Experience</span>
        </h2>

        <Row>
          <Col lg={11} className="mx-auto">
            {/* Full-time */}
            <div className="experience-category fade-in fade-in-delay-1">
              <div className="timeline">
                {workExperience.map((exp, i) => (
                  <div key={i} className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-card">
                      <div className="timeline-header">
                        <div>
                          <div className="timeline-role">{exp.role}</div>
                          <div className="timeline-company">{exp.company}</div>
                        </div>
                        <div className="timeline-date">{exp.date}</div>
                      </div>
                      <ul className="timeline-points">
                        {exp.points.map((p, j) => (
                          <li key={j}>{p}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Internships */}
            <div className="experience-category fade-in fade-in-delay-2">
              <h3 className="experience-category-title purple">Internships</h3>
              <div className="timeline">
                {internships.map((exp, i) => (
                  <div key={i} className="timeline-item">
                    <div className="timeline-dot"></div>
                    <div className="timeline-card">
                      <div className="timeline-header">
                        <div>
                          <div className="timeline-role">{exp.role}</div>
                          <div className="timeline-company">{exp.company}</div>
                          {exp.location && (
                            <div className="timeline-location">{exp.location}</div>
                          )}
                        </div>
                        <div className="timeline-date">{exp.date}</div>
                      </div>
                      <ul className="timeline-points">
                        {exp.points.map((p, j) => (
                          <li key={j}>{p}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Competitions */}
            <div className="experience-category fade-in fade-in-delay-3">
              <h3 className="experience-category-title purple">Competitions</h3>
              <Row>
                {competitions.map((comp, i) => (
                  <Col md={6} key={i} className="mb-4">
                    <div className="competition-card">
                      <div className="competition-image-wrapper">
                        {comp.image ? (
                          <img src={comp.image} alt={comp.title} className="competition-image" />
                        ) : (
                          <div className="competition-image-placeholder">
                            <AiOutlineTrophy />
                            <span>Add Image</span>
                          </div>
                        )}
                      </div>
                      <div className="competition-title">{comp.title}</div>
                      <div className="competition-meta">
                        {comp.org} &bull; {comp.location}
                      </div>
                      <ul className="timeline-points">
                        {comp.points.map((p, j) => (
                          <li key={j}>{p}</li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Experience;
